import AcceptIcon from '@/shared/assets/icons/acceptDeal.svg?react'
import { BaseDialog } from '@/shared/components'

type Props = {
  amount: number
  isModalOpen: boolean
  onAction: () => void
  setIsModalOpen: (value: boolean) => void
}

export const AcceptOrderDialog = ({ amount, isModalOpen, setIsModalOpen, onAction }: Props) => {
  return (
    <BaseDialog
      isVisible={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      onAction={onAction}
      actionButtonName="Подвердить"
      xButton={false}
      iconTitle={<AcceptIcon className="text-[var(--status-purple-fill)]" />}
    >
      <p className="text-[20px] mt-[-8px]">
        Подтверждаю, что перевод был на сумму <span>{amount} RUB</span>
      </p>
    </BaseDialog>
  )
}
